/**************************************************************************************************************************
 Copyright (c) 2024 WorkEarly Results LLP

     Name: affiliations-softwares.section.tsx
   Author: Harikrishnan Gangadharan
 Comments: 

/**************************************************************************************************************************
 IMPORTS
***************************************************************************************************************************/
import { FunctionComponent } from 'react';
import { motion } from 'framer-motion';

import Statics from '@/constants/statics';
import Section from '@/shared/section';
/**************************************************************************************************************************
 IMPLEMENTATIONS
***************************************************************************************************************************/
const AffiliationsAndSoftwares: FunctionComponent = () => {
  return (
    <Section id="affiliations">
      <div className="w-full flex flex-col lg:flex-row flex-wrap items-center justify-center gap-5">
        {Statics.AffiliationScrollItems.map(({ id, src }, idx: number) => (
          <motion.div
            key={id}
            className="w-[200px] h-[200px] flex flex-wrap items-center justify-center"
            initial="initial"
            whileInView="entry"
            viewport={{ once: true }}
            variants={{
              initial: {
                x: 50 + idx * 25,
                opacity: 0
              },
              entry: {
                x: 0,
                opacity: 1
              }
            }}
            transition={{
              duration: 0.5
            }}
          >
            <img src={src} alt="affiliation-icon" className="w-[200px] h-[200px]" />
          </motion.div>
        ))}
      </div>
    </Section>
  );
};

export default AffiliationsAndSoftwares;
